import { IAttribute } from "../../model/formconfiguration/Attribute";
import Model from "../../model/Model";
import ValidatableObject from "../../model/validation/ValidatableObject";

export interface TFormConfigQualifierAttribute {
  attributeCode: string;
  labelVisible: boolean;
  name: string;
  orderNumberInsertDisplay: number;
  qualifierCode: string;
  required: boolean;
  shortDisplay: boolean;
  validation: boolean;
  visible: boolean;
  attribute: IAttribute;
}

export interface IFormConfigQualifierAttribute
  extends TFormConfigQualifierAttribute {}

const FormConfigQualifierAttribute = Model(
  (model: TFormConfigQualifierAttribute): IFormConfigQualifierAttribute => {
    const _formConfigQualifierAttribute: TFormConfigQualifierAttribute = Object.assign(
      {},
      model
    );

    let create = (
      formConfigQualifierAttribute: IFormConfigQualifierAttribute
    ): IFormConfigQualifierAttribute => {
      let obj = ValidatableObject(formConfigQualifierAttribute);
      return obj;
    };

    let formConfigQualifierAttribute = {
      get attributeCode() {
        return _formConfigQualifierAttribute.attributeCode;
      },
      set attributeCode(value) {
        _formConfigQualifierAttribute.attributeCode = value;
      },
      get labelVisible() {
        return _formConfigQualifierAttribute.labelVisible;
      },
      set labelVisible(value) {
        _formConfigQualifierAttribute.labelVisible = value;
      },
      get name() {
        return _formConfigQualifierAttribute.name;
      },
      set name(value) {
        _formConfigQualifierAttribute.name = value;
      },
      get orderNumberInsertDisplay() {
        return _formConfigQualifierAttribute.orderNumberInsertDisplay;
      },
      set orderNumberInsertDisplay(value) {
        _formConfigQualifierAttribute.orderNumberInsertDisplay = value;
      },
      get qualifierCode() {
        return _formConfigQualifierAttribute.qualifierCode;
      },
      set qualifierCode(value) {
        _formConfigQualifierAttribute.qualifierCode = value;
      },
      get required() {
        return _formConfigQualifierAttribute.required;
      },
      set required(value) {
        _formConfigQualifierAttribute.required = value;
      },
      get shortDisplay() {
        return _formConfigQualifierAttribute.shortDisplay;
      },
      set shortDisplay(value) {
        _formConfigQualifierAttribute.shortDisplay = value;
      },
      get validation() {
        return _formConfigQualifierAttribute.validation;
      },
      set validation(value) {
        _formConfigQualifierAttribute.validation = value;
      },
      get visible() {
        return _formConfigQualifierAttribute.visible;
      },
      set visible(value) {
        _formConfigQualifierAttribute.visible = value;
      },
      get attribute() {
        return _formConfigQualifierAttribute.attribute;
      },
      set attribute(value) {
        _formConfigQualifierAttribute.attribute = value;
      }
    };
    return create(formConfigQualifierAttribute);
  }
);

export default FormConfigQualifierAttribute;
